import type { ReactNode } from "react"

interface FullWidthProps {
    children: ReactNode
    className?: string
}

export default function FullWidth({ children, className = "" }: FullWidthProps) {
    return <div className={`w-screen -mx-[calc((100vw-100%)/2)] ${className}`}>{children}</div>
}
